"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeechBubbleArrow = void 0;
var react_1 = __importDefault(require("react"));
var SpeechBubbleArrow = function (_a) {
    var className = _a.className;
    return (react_1.default.createElement("svg", { className: className, width: "34px", height: "16px", viewBox: "0 0 34 16", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("g", { id: "Page-1" },
            react_1.default.createElement("g", { id: "Artboard", transform: "translate(-157.000000, -56.000000)" },
                react_1.default.createElement("g", { id: "Rectangle", transform: "translate(157.000000, 56.000000)" },
                    react_1.default.createElement("g", { id: "path-1" },
                        react_1.default.createElement("path", { id: "path-1", fill: "none", stroke: "#b3b3b3", d: "M0.7,15.9c3.6,0,6.9-2,8.7-5.1l5.1-9.2c0.8-1.4,2.6-2,4.1-1.2c0.5,0.3,0.9,0.7,1.2,1.2\n\t\t\t\t\tl5.1,9.2c1.7,3.2,5.1,5.1,8.7,5.1" })))),
            react_1.default.createElement("path", { fill: "#FFFFFF", d: "M24.9,10.8l-5.1-9.2c-0.3-0.5-0.7-0.9-1.2-1.2c-1.4-0.8-3.3-0.3-4.1,1.2l-5.1,9.2c-1.8,3.2-5.1,5.1-8.7,5.1\n\t\tv2.9h32.9v-2.9C30,15.9,26.6,13.9,24.9,10.8z" }))));
};
exports.SpeechBubbleArrow = SpeechBubbleArrow;
